import { Static, Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../../routes/createPathParameter';
import { createdResponse, removedResponse } from '../../../routes/defaultResponses';
import { makeNullable } from '../../../utils/typeboxHelpers';
import { utProjectTableSchema } from './utProjectTableSchema';

const getUtProjectsSearchParametersSchema = Type.Object({
    name: Type.Optional(Type.String()),
});

export type GetUtProjectsSearchParametersSchema = Static<typeof getUtProjectsSearchParametersSchema>;

export const utProjectPaths = {
    '/api/utProjects': {
        get: {
            operationId: 'utProjectControllers.getAllUtProjects',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                items: Type.Array(
                                    Type.Intersect([
                                        Type.Pick(utProjectTableSchema, [
                                            'id',
                                            'name',
                                            'deviceName',
                                            'pilotName',
                                            'surveyorName',
                                            'description',
                                            'createdOnDateTime',
                                            'clientName',
                                            'surveyId',
                                        ]),
                                        Type.Object({
                                            objects: Type.Object({ name: makeNullable(Type.String()) }),
                                        }),
                                        Type.Object({
                                            surveys: Type.Object({
                                                description: makeNullable(Type.String()),
                                                surveyedOn: makeNullable(Type.String()),
                                            }),
                                        }),
                                    ]),
                                ),
                            }),
                        },
                    },
                },
            },
            parameters: [
                {
                    name: 'searchParameters',
                    in: 'query',
                    schema: getUtProjectsSearchParametersSchema,
                },
            ],
        },
    },
    '/api/utProjects/{projectId}': {
        parameters: [createPathGuidParameter('projectId')],
        delete: {
            operationId: 'utProjectControllers.delete',
            responses: {
                ...removedResponse,
            },
        },
    },
    '/api/utProjects/{projectId}/copy': {
        parameters: [createPathGuidParameter('projectId')],
        post: {
            operationId: 'utProjectControllers.copy',
            responses: {
                ...createdResponse,
            },
        },
    },
    '/api/surveys/{surveyId}/projects': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'utProjectControllers.getProjectsInSurvey',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(Type.Pick(utProjectTableSchema, ['id', 'name', 'deviceName', 'pilotName', 'surveyorName'])),
                        },
                    },
                },
            },
        },
    },
} as const;
